import React, { useState } from 'react';
import { CRM_COLORS } from '../theme/crmColors';
import { Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import Authentication from '../components/auth/Authentication';
import BoardV2List from '../components/avatarAncV2/BoardV2List';
import ViewToggle, { ViewMode } from '../components/avatarAnc/ViewToggle';
import IntegratedHeader from '../components/header/IntegratedHeader';
import { CustomReducerState } from '../redux/reducers';
import { User } from '../utils/types';
import { ancsV2, redirect_to_ancs_v2 } from './paths';

/** Rikutec board v2: the traceability-form view of the installations (rikutec_board_v2_view). */
const AvatarAncV2Page = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();
    const [viewMode, setViewMode] = useState<ViewMode>('cards');

    return (
        <Authentication redirectTo={redirect_to_ancs_v2}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        gridTemplateColumns: 'minmax(0, 1fr)',
                        overflowX: 'hidden',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={ancsV2}
                        eyebrow={translate('app.headers.eyebrow.every2Hours')}
                        title={translate('app.headers.ancs')}
                        actions={<ViewToggle viewMode={viewMode} setViewMode={setViewMode} />}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minWidth: 0,
                            minHeight: 0,
                            height: '100%',
                        }}
                    >
                        <BoardV2List viewMode={viewMode} />
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default AvatarAncV2Page;
